var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 295.24 295.24",
    style: {
      enableBackground: "new 0 0 295.24 295.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M280.952,57.144h-14.286V0.001H104.762v57.143H90.476c-7.876,0-14.286,6.41-14.286,14.286v14.286h-9.524V71.43 c0-7.876-6.41-14.286-14.286-14.286H14.286C6.41,57.144,0,63.553,0,71.43v166.667c0,7.876,6.41,14.286,14.286,14.286h38.095 c7.876,0,14.286-6.41,14.286-14.286v-9.524h9.524v9.524c0,7.876,6.41,14.286,14.286,14.286h14.286v42.857h161.905v-42.857h14.286 c7.876,0,14.286-6.41,14.286-14.286V71.43C295.238,63.553,288.829,57.144,280.952,57.144z M57.143,238.095 c0,2.629-2.133,4.762-4.762,4.762H14.286c-2.629,0-4.762-2.133-4.762-4.762V71.43c0-2.629,2.133-4.762,4.762-4.762h38.095 c2.629,0,4.762,2.133,4.762,4.762V238.095z M76.191,219.048h-9.524V95.238h9.524V219.048z M114.286,9.524h142.857v47.619H114.286 V9.524z M104.762,214.287v9.524H100v-14.286h171.429v14.286h-4.762v-9.524H104.762z M257.143,285.714H114.286v-61.904h142.857 V285.714z M285.715,238.095h-0.001c0,2.629-2.133,4.762-4.762,4.762h-14.286v-9.524h14.286v-33.333H90.476v33.333h14.286v9.524 H90.476c-2.629,0-4.762-2.133-4.762-4.762V71.43c0-2.629,2.133-4.762,4.762-4.762h14.286h161.905h14.286 c2.629,0,4.762,2.133,4.762,4.762V238.095z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 123.811,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.048,
    y: 123.811,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 123.811,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.143,
    y: 123.811,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 142.857,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.048,
    y: 142.857,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 142.857,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.143,
    y: 142.857,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 161.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.048,
    y: 161.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 161.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.143,
    y: 161.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.714,171.43h85.714v-47.619h-85.714V171.43z M195.238,133.334h66.667v28.571h-66.667V133.334z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.81,
    y: 19.048,
    width: 123.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.81,
    y: 38.095,
    width: 123.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.81,
    y: 266.667,
    width: 123.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.81,
    y: 247.62,
    width: 123.81,
    height: 9.524
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.1a4615ca27128827e883f5751a11e8ae.svg";
export { ForwardRef as ReactComponent };